import { atom } from "jotai";

/**
 * X-coordinate (px) of the PC header cart icon, published by `PcCartMenu` and
 * read by `FlyingImage` to aim the add-to-cart flight animation.
 *
 * Kept in its own module so lightweight consumers (every product card renders
 * `FlyingImage`) can import just this atom WITHOUT statically pulling in the
 * whole `PcCartMenu` tree — which transitively drags the cart-items list and
 * `moment-timezone` (~708KB) into the product-card bundle.
 */
export const cartXAtom = atom(0);
